<template>
  <div @click="hideKeyboard" :class="[$style.wrapper, !isOpen ? $style.hide : null]" v-if="object">
    <div :class="$style.content" :style="contentStyle">
      <div v-if="this.isOpen" :class="$style.back" @click="backToOpenCard">
        <img src="../assets/img/back.svg" alt="" />
      </div>
      <div :class="$style.header">
        <h1 :class="$style.title">Заполните заявку</h1>
        <p :class="$style.subtitle">
          и мы свяжемся с вами по объекту «{{ object.header }}»<template v-if="layoutLabel"
            >, {{ layoutLabel }}</template
          >
        </p>
      </div>
      <div :class="$style.bid">
        <input
          v-model="formUser.firstName"
          type="text"
          placeholder="Имя*"
          :class="[$style.button_transparent, errorMessages.firstName ? $style.errorInput : '']"
          @focus="handleFocus"
          @blur="handleBlur"
        />
        <div v-if="errorMessages.firstName" :class="$style.error">
          {{ errorMessages.firstName }}
        </div>

        <input
          v-model="formUser.phone"
          type="tel"
          placeholder="Номер телефона*"
          :class="[$style.button_transparent, errorMessages.phone ? $style.errorInput : '']"
          ref="phoneInput"
          @focus="handleFocus"
          @blur="handleBlur"
        />
        <div v-if="errorMessages.phone" :class="$style.error">{{ errorMessages.phone }}</div>

        <input
          v-model="formUser.comment"
          type="text"
          placeholder="Комментарий"
          :class="$style.button_transparent"
          @focus="handleFocus"
          @blur="handleBlur"
        />

        <div v-if="errorMessage" :class="$style.error">{{ errorMessage }}</div>

        <button
          :class="[$style.button, isSubmitted ? $style.success : '']"
          @click="handleSubmit"
          :disabled="isSubmitted"
        >
          {{ buttonText }}
        </button>
        <p :class="$style.note">
          Нажимая «Отправить», вы соглашаетесь на обработку имени и номера телефона для связи с
          вами.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Inputmask from 'inputmask';

export default {
  props: {
    object: {
      type: Object,
      required: true,
    },
    link: {
      type: String,
      required: true,
    },
    layoutLabel: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isOpen: true,
      isSubmitted: false,
      buttonText: 'Отправить',
      formUser: {
        firstName: '',
        phone: '',
        comment: '',
      },
      errorMessages: {
        firstName: '',
        phone: '',
      },
      errorMessage: '',
      contentStyle: {},
    };
  },
  mounted() {
    const phoneInput = this.$refs.phoneInput;
    const im = new Inputmask('+7(999)999-99-99');
    im.mask(phoneInput);
  },
  methods: {
    validateForm() {
      let isValid = true;

      if (!this.formUser.firstName) {
        this.errorMessages.firstName = 'Пожалуйста, введите имя';
        isValid = false;
      } else {
        this.errorMessages.firstName = '';
      }

      if (!this.formUser.phone) {
        this.errorMessages.phone = 'Пожалуйста, введите номер телефона';
        isValid = false;
      } else if (!this.validatePhone(this.formUser.phone)) {
        this.errorMessages.phone = 'Пожалуйста, введите корректный номер телефона';
        isValid = false;
      } else {
        this.errorMessages.phone = '';
      }

      return isValid;
    },

    validateName(name) {
      return name.trim().length > 0;
    },

    validatePhone(phone) {
      const phoneRegex = /^\+7\(\d{3}\)\d{3}-\d{2}-\d{2}$/;
      return phoneRegex.test(phone);
    },

    async handleSubmit() {
      if (!this.validateForm()) {
        return;
      }

      this.errorMessage = '';
      this.isSubmitted = true;
      this.buttonText = 'Заявка отправлена';

      const formData = {
        name: this.formUser.firstName,
        phone: this.formUser.phone,
        comment: this.formUser.comment,
        object_id: this.object.id,
        object_header: this.layoutLabel
          ? `${this.object.header}, ${this.layoutLabel}`
          : this.object.header,
        link: this.link,
      };

      this.$store.commit('changeLoading', true);
      await this.$store.dispatch('submitForm', formData);
      this.$store.commit('changeLoading', false);
    },

    handleFocus() {
      this.contentStyle = {
        paddingBottom: '300px',
      };
    },

    handleBlur() {
      window.scrollTo(0, 0);
      this.contentStyle = {
        paddingBottom: '50px',
      };
    },
    hideKeyboard() {
      if (window.Telegram && window.Telegram.WebApp) {
        window.Telegram.WebApp.closeKeyboard();
      }
    },

    backToOpenCard() {
      this.isOpen = false;
      setTimeout(() => {
        this.$emit('backToOpenCard');
      }, 250);
    },
  },
};
</script>

<style lang="scss" module>
@keyframes show {
  0% {
    left: -100%;
  }
  100% {
    left: 0;
  }
}

@keyframes hide {
  0% {
    left: 0;
  }
  100% {
    left: -100%;
  }
}

.wrapper {
  position: fixed;
  z-index: 50;
  overflow-y: auto;
  background: $background;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  margin: 0 auto;
  animation: show 0.25s ease;
  &.hide {
    animation-name: hide;
    animation-duration: 0.26s;
  }
}

.content {
  padding: 16px;
}

.back {
  margin-bottom: 71px;
  width: 39px;
  height: 39px;
}

.header {
  margin: 0 auto;
  text-align: center;
  margin-bottom: 16px;
}

.title {
  font-weight: 600;
  font-size: 22px;
  line-height: 28px;
  color: $white;
}

.subtitle {
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: $muted;
}
.note {
  margin-top: 12px;
  font-size: 10px;
  line-height: 14px;
  color: #777;
}

.button_transparent {
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 14px 0px 14px 16px;
  width: 100%;
  background-color: transparent;
  color: $white;
  border: 1px solid #3a3a3a;
  background-color: $bg-dark;
  border-radius: 12px;
  outline: none;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 16px;
  box-sizing: border-box;
}

.button_transparent::placeholder {
  color: $white;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
}

.error {
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 1px;
  color: $red;
  margin: 0 auto;
  margin-bottom: 10px;
  text-align: center;
}

.button {
  margin: 20px auto 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 17px 0px;
  width: 100%;
  background-color: $primary;
  color: $white;
  border: none;
  border-radius: 12px;
  text-align: center;
  font-weight: 600;
  font-size: 12px;
  line-height: 15px;
}

.button.success {
  background-color: #27d045;
  color: $white;
}
</style>
